module.exports = "<p>\r\n    communication-room works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/communication-room/communication-room.component.html
// module id = ./src/app/app_manager/app_element/communication-room/communication-room.component.html
// module chunks = main